export const GET_ADDRESS = 'address/get';
export const GET_ADDRESS_SUCCESS = 'address/get/success';

export const GET_ADDRESS_TRANSACTIONS = 'address/transactions/get';
export const GET_ADDRESS_TRANSACTIONS_SUCCESS =
  'address/transactions/get/success';
